import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

const Card = (props) => {
    const { articlePic, body, title, path, sub } = props;
    console.log(articlePic)
    return ( 
        <>
          <div className="card">
              <div className="card-header">{ body }</div>
                 <Img fluid={articlePic} className="card-image-top" />
              <div className="card-body">
                <h5 className="card-title">{ title }</h5>
                <p className="card-text">{ sub } </p>
                <Link to={path} className="btn btn-primary" style={{ backgroundImage: 'linear-gradient(to right bottom, #430089, #82ffa1)', fontSize:8  }}>View article</Link>
              </div> 
          </div>
        </>
     );
}
 
export default Card;